import { takeLatest, call, put } from 'redux-saga/effects'
import { GET_PROFILES } from './actionTypes'
import { setLoader } from '../loader/actions'
import profileService from '../../supabaseServices/ProfileService'
import { setProfiles } from './actions'

export function* getProfileSagaFn(payload) {
  try {
    yield put(setLoader(true))
    const res = yield call(profileService.getPaginatedProfiles, 1)
    yield put(setProfiles(res))
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoader(false))
  }
}

export default function* profileSaga() {
  yield takeLatest(GET_PROFILES, getProfileSagaFn())
}
